import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { updateInvoice } from '../api/invoicesApi';

export default function useUpdateInvoice() {
    return useMutation({
        mutationFn: ({ id, body }) => updateInvoice(id, body),
        onSuccess: () => toast.success('Invoice updated'),
        onError: (err) => toast.error(err?.message ?? 'Failed to update invoice'),
    });
}
